export function hasFieldCondition(properties, fieldName) {
  return properties?.hasOwnProperty(fieldName);
}

export function findBlockById(properties, block) {
  return properties.blocks_layout?.items?.find(
    (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
  );
}

export function isContentType(properties, type) {
  return properties?.['@type'] === type;
}
